module.exports = __webpack_public_path__ + "img/box4.13b50a7c.svg";